import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import _ from 'lodash'
import { injectIntl, defineMessages } from 'react-intl'
import {
  initAnswers,
  updateAnswers,
  setResult,
} from '../../common/tests/actions'
import { TextInput, SelectInput, LessonMediaContent } from '../components'

class WordboxTestPreview extends React.Component {
  render() {
    const { lesson, intl } = this.props
    
    const { fillIndexes, options } = lesson.wordbox
    let { text } = lesson.wordbox

    const newText = []

    let i = 0
    while (i < text.length) {
      const range = fillIndexes.find(range => range.from && range.from <= i && range.to > i)

      if (range) {
        newText.push(text.slice(range.from, range.to).join(' '))
        let j = 0
        while (j < range.to - range.from - 1) {
          newText.push('')
          j += 1
        }
        i = range.to
        continue
      } else {
        newText.push(text[i])
      }
      i += 1
    }

    text = newText

    return (
      <div className="wordbox-item wordbox-item-preview">
        {/*
        <p className="instructions">
          {lesson.instructions || intl.formatMessage(messages.fillWords)}
        </p>
        <LessonMediaContent lesson={lesson} />
        */}
        <div className="wordbox-text">
          {
            text.map((w, i) => {
              const oneWordIndex = fillIndexes.indexOf(i)

              if (oneWordIndex !== -1) {
                if (options && options[i]) {
                  return (
                    <React.Fragment key={`${w} ${i}`}>
                      <SelectInput
                        disabled={true}
                        options={_.shuffle(options[i].map(o => ({ key: o, label: o })))}
                        value={w}
                      />
                    </React.Fragment>
                  )
                }

                return (
                  <React.Fragment key={`${w} ${i}`}>
                    <TextInput
                      className="wordbox-input"
                      disabled={true}
                      value={w}
                    />
                  </React.Fragment>
                )
              }

              const wordsRangeIndex = fillIndexes.findIndex(range =>
                range.from && range.from <= i && range.to > i)

              if (wordsRangeIndex !== -1) {
                const range = fillIndexes[wordsRangeIndex]
                if (range.from !== i) {
                  /* for multiple words render only one text input */
                  return null
                }
                if (options && options[i]) {
                  return (
                    <React.Fragment key={`${w} ${i}`}>
                      <SelectInput
                        disabled={true}
                        options={_.shuffle(options[range.from].map(o => ({ key: o, label: o })))}
                        value={w}
                      />
                    </React.Fragment>
                  )
                }
                return (
                  <React.Fragment key={`${w} ${i}`}>
                    <TextInput
                      className="wordbox-input"
                      disabled={true}
                      value={w}
                      autoComplete="off"
                      autoCorrect="off"
                      autocaPitalize="off"
                      spellCheck="false"
                    />
                  </React.Fragment>
                )
              }

              return (<span
                key={`${w}${i}`}
                className={['?', ',', '.', '!'].includes(text[i + 1]) ? 'no-word-space-after' : ''}
              >
                {w}
              </span>)
            })
          }
        </div>
      </div>
    )
  }
}

WordboxTestPreview.defaultProps = {
  lesson: null,
  showResult: false,
  inputFocusHandler: null,
  updateCursorIndex: null,
  initAnswers: null,
  updateAnswers: null,
  setResult: null,
  points: 0,
  maxPoints: 0,
  answers: [],
}

WordboxTestPreview.propTypes = {
  intl: PropTypes.object.isRequired,
  showResult: PropTypes.bool,
  lesson: PropTypes.object,
  points: PropTypes.number,
  maxPoints: PropTypes.number,
  answers: PropTypes.array,
  inputFocusHandler: PropTypes.func,
  updateCursorIndex: PropTypes.func,
  initAnswers: PropTypes.func,
  updateAnswers: PropTypes.func,
  setResult: PropTypes.func,
}

const enhance = compose(
  connect(state => ({
    exam: state.tests.exam,
  }), { updateAnswers, initAnswers, setResult }, null, { withRef: true }),
)

export default enhance(WordboxTestPreview)

const messages = defineMessages({
  fillWords: {
    id: 'wordboxTest.fillWords',
    defaultMessage: 'Doplňte chýbajúce slová v texte.',
  },
  points: {
    id: 'wordboxTest.points',
    defaultMessage: 'Body',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/WordboxTestPreview.js